import Panel from "./Panel";
import MetaRow from "./MetaRow";

/* ── 03 · Hook Scorer ── */
const HookScorerMock = () => {
  const hooks = [
    {
      r: 1,
      t: "“Why your $80 serum isn’t working”",
      tags: ["Question", "Contradiction", "Curiosity"],
      s: 46,
      top: true,
    },
    {
      r: 2,
      t: "“The 14-day glow you’ve been chasing”",
      tags: ["Bold claim", "Aspirational"],
      s: 38,
    },
    {
      r: 3,
      t: "“30 days. One bottle. Real results.”",
      tags: ["Bold claim", "Numbers"],
      s: 32,
    },
    {
      r: 4,
      t: "“Dermatologist-approved skincare routine”",
      tags: ["Authority", "Generic"],
      s: 21,
    },
    {
      r: 5,
      t: "“Glow in 14 days with our serum”",
      tags: ["Bold claim", "Brand-led"],
      s: 19,
    },
  ];
  return (
    <Panel>
      <MetaRow label="Hook Scorer · 5 hooks ranked" right="Cat. Avg · 27%" />
      <hr className="border-white/10 " />
      <div className="flex flex-1 flex-col gap-3">
        {hooks.map((h) => (
          <div
            key={h.r}
            className={`flex items-center gap-3 px-3 py-4 ${
              h.top
                ? "border-[#4F3DF0]/50 bg-[#3257F90F]/[6%]"
                : "border-white/10 bg-white/[2%]"
            }`}
          >
            <span
              className={`shrink-0 font-serif text-[14px] italic ${
                h.top ? "text-[#A9A0FF]" : "text-white/35"
              }`}
            >
              {h.r}
            </span>
            <div className="min-w-0 flex-1">
              <p className="truncate text-[12px] font-medium text-white/80">
                {h.t}
              </p>
              <div className="mt-1 flex flex-wrap items-center gap-x-1.5 gap-y-0.5 text-[8px] font-medium uppercase tracking-[0.3em] text-[#A59881] ">
                {h.tags.map((tag, i) => (
                  <span key={tag} className="flex items-center gap-1.5">
                    {i > 0 && (
                      <span className="text-[#4500FF]  ">&#8226; </span>
                    )}
                    {tag}
                  </span>
                ))}
              </div>
            </div>
            <div className="flex shrink-0 gap-1 flex-col items-end">
              <span className="font-serif text-[18px] italic leading-none text-white">
                {h.s}%
              </span>
              <span className="mt-0.5 text-[7px] uppercase tracking-[0.12em] text-[#A59881] ">
                Pred. TSR
              </span>
            </div>
          </div>
        ))}
      </div>
    </Panel>
  );
};

export default HookScorerMock;
